<mojo-original-layout *ngIf="layout === 'original'"></mojo-original-layout>
<mojo-empty-layout *ngIf="layout === 'empty'"></mojo-empty-layout>
